import browser from 'browser-detect'
export const result = browser()

const _classes = []
if (result.hasOwnProperty("mobile")) {
  _classes.push("mobile-" + result.mobile)
}

if (result.hasOwnProperty("name")) {
  _classes.push("browser-" + result.name)
}

if (result.hasOwnProperty("os")) {
  _classes.push("os-" + result.os.split(" ", 1))
}

if (result.hasOwnProperty("version")) {
  _classes.push("version-" + result.version.split(".", 1))
}

export const browserDetect = {
  detect : _classes.join(" ")
}

export const fromAflac = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const hasAflacParam = urlParams.get('from') === 'aflac'
  const hasAflacReferrer = document.referrer.indexOf('aflac') !== -1
  return hasAflacParam || hasAflacReferrer
}

export const fromCancerSupport = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const hasAflacParam = urlParams.get('from') === 'cancer-support'
  const hasAflacReferrer = document.referrer.indexOf('cancer-support') !== -1
  return hasAflacParam || hasAflacReferrer
}



// WEBPACK FOOTER //
// ./src/modules/common.js